import api from './api';
import { Task, Level, UserLevel } from '../types';

export const taskService = {
  // Admin: System Tasks
  listTasksAdmin: async (): Promise<{ tasks: Task[] }> => {
    const response = await api.get('/system-tasks/admin');
    return response.data;
  },

  createTask: async (data: {
    title: string;
    description?: string;
    points: number;
    task_type: Task['task_type'];
    requirements?: { [key: string]: any };
    is_active?: boolean;
  }): Promise<{ task: Task }> => {
    const response = await api.post('/system-tasks/admin', data);
    return response.data;
  },

  updateTask: async (taskId: number, data: Partial<Task>): Promise<{ task: Task }> => {
    const response = await api.put(`/system-tasks/admin/${taskId}`, data);
    return response.data;
  },

  deleteTask: async (taskId: number): Promise<void> => {
    await api.delete(`/system-tasks/admin/${taskId}`);
  },

  // Admin: Levels
  listLevelsAdmin: async (): Promise<{ levels: Level[] }> => {
    const response = await api.get('/system-tasks/admin/levels');
    return response.data;
  },

  createLevel: async (data: {
    level_number: number;
    required_points: number;
    name?: string;
    description?: string;
    features?: string[];
  }): Promise<{ level: Level }> => {
    const response = await api.post('/system-tasks/admin/levels', data);
    return response.data;
  },

  updateLevel: async (levelId: number, data: Partial<Level>): Promise<{ level: Level }> => {
    const response = await api.put(`/system-tasks/admin/levels/${levelId}`, data);
    return response.data;
  },

  deleteLevel: async (levelId: number): Promise<void> => {
    await api.delete(`/system-tasks/admin/levels/${levelId}`);
  },

  // User: Tasks
  listTasks: async (chapterId?: number, taskCategory?: 'system' | 'course'): Promise<{ tasks: Task[] }> => {
    const params: any = {};
    if (chapterId) params.chapter_id = chapterId;
    if (taskCategory) params.task_category = taskCategory;
    const response = await api.get('/system-tasks', { params });
    return response.data;
  },

  completeTask: async (taskId: number): Promise<{ user_task: any; user_level: UserLevel }> => {
    const response = await api.post(`/system-tasks/${taskId}/complete`);
    return response.data;
  },

  // User: Level
  getMyLevel: async (): Promise<UserLevel> => {
    const response = await api.get('/system-tasks/my-level');
    return response.data;
  },

  listLevels: async (): Promise<{ levels: Level[] }> => {
    const response = await api.get('/system-tasks/levels');
    return response.data;
  },
};

